import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import WorkIcon from "@mui/icons-material/Work";
import SchoolIcon from "@mui/icons-material/School";
import StarIcon from "@mui/icons-material/Star";
import moment from "moment/moment";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import CallIcon from "@mui/icons-material/Call";
import CalculateIcon from "@mui/icons-material/Calculate";
import AddIcon from "@mui/icons-material/Add";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import { Chip } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import PlaceIcon from "@mui/icons-material/Place";
import EditIcon from "@mui/icons-material/Edit";

const LogTimelineComponent = ({ timelineData }) => {
  // Function to determine icon based on action_type
  const getIcon = (actionType) => {
    switch (actionType) {
      case "Lead Created by Agent":
        return <AddIcon />;
      case "Lead Created by bulk upload":
        return <AddIcon />;
      case "Lead Created by BDM":
        return <AddIcon />;
      case "Follow-up by Agent":
        return <EditCalendarIcon />;
      case "On Call Discussion By BDM":
        return <CallIcon />;
      case "Meeting_Office Completed":
        return <MeetingRoomIcon />;
        case "Meeting Completed":
          return <MeetingRoomIcon />;
      case "Meeting_Field Completed":
        return <PlaceIcon />;
        case "Site Visit Completed":
        return <PlaceIcon />;
      case "Estimation Requested":
        return <CalculateIcon />;
      case "Estimation Need for Approval":
        return <CalculateIcon />;
      case "Estimation Generated":
        return <CalculateIcon />;
      case "Estimation Shared":
        return <CalculateIcon />;
      case "Estimation Rejected":
        return <CalculateIcon />;
      case "Lead Converted":
        return <SyncIcon />;
      case "Lead Edited By Manual":
        return <EditIcon />;
      case "Lead Edited By Call":
        return <EditIcon />;
      case "Lead Edited By Supervisor":
        return <EditIcon />;
      default:
        return <StarIcon />;
    }
  };

  // Function to determine icon style based on action_type
  const getIconStyle = (actionType) => {
    switch (actionType) {
      case "Lead Created by Agent":
        return {
          background: "linear-gradient(to right, #42e695, #3bb2b8)",
          color: "#fff",
        }; // Green-Teal Gradient
      case "Lead Created by bulk upload":
        return {
          background: "linear-gradient(to right, #ff7e5f, #feb47b)",
          color: "#fff",
        }; // Peach-Orange Gradient
      case "Lead Created by BDM":
        return {
          background: "linear-gradient(to right, #ff7e5f, #feb47b)",
          color: "#fff",
        }; // Peach-Orange Gradient
      case "Follow-up by Agent":
        return {
          background: "linear-gradient(to right, #6a11cb, #2575fc)",
          color: "#fff",
        }; // Purple-Blue Gradient
      case "On Call Discussion By BDM":
        return {
          background: "linear-gradient(to right, #ff9966, #ff5e62)",
          color: "#fff",
        }; // Orange-Red Gradient
      case "Meeting_Office Completed":
        return {
          background: "linear-gradient(to right, #f857a6, #ff5858)",
          color: "#fff",
        }; // Pink-Red Gradient
        case "Meeting Completed":
        return {
          background: "linear-gradient(to right, #f857a6, #ff5858)",
          color: "#fff",
        }; // Pink-Red Gradient
      case "Site Visit Completed":
        return {
          background: "linear-gradient(to right, #43cea2, #185a9d)",
          color: "#fff",
        }; // Teal-Navy Blue Gradient
        case "Meeting_Field Completed":
          return {
            background: "linear-gradient(to right, #43cea2, #185a9d)",
            color: "#fff",
          }; // Teal-Navy Blue Gradient
      case "Estimation Requested":
        return {
          background: "linear-gradient(to right, #00c6ff, #0072ff)",
          color: "#fff",
        }; // Light Blue-Dark Blue Gradient
      case "Estimation Need for Approval":
        return {
          background: "linear-gradient(to right, #f7971e, #ffd200)",
          color: "#fff",
        }; // Orange-Yellow Gradient
      case "Estimation Generated":
        return {
          background: "linear-gradient(to right, #4facfe, #00f2fe)",
          color: "#fff",
        }; // Sky Blue Gradient
      case "Estimation Shared":
        return {
          background: "linear-gradient(to right, #36d1dc, #5b86e5)",
          color: "#fff",
        }; // Cyan-Indigo Gradient
      case "Estimation Rejected":
        return {
          background: "linear-gradient(to right, #36d1dc, #5b86e5)",
          color: "#fff",
        }; // Cyan-Indigo Gradient
      case "Lead Converted":
        return {
          background: "linear-gradient(to right, #56ab2f, #a8e063)",
          color: "#fff",
        }; // Green Gradient
      case "Lead Edited By Manual":
        return {
          background: "linear-gradient(to right, #f39c12, #d35400)", // Orange Gradient
          color: "#fff",
        };
      case "Lead Edited By Call":
        return {
          background: "linear-gradient(to right, #f39c12, #d35400)", // Orange Gradient
          color: "#fff",
        };
      case "Lead Edited by Supervisor":
        return {
          background: "linear-gradient(to right, #f39c12, #d35400)", // Orange Gradient
          color: "#fff",
        };
      default:
        return {
          background: "linear-gradient(to right, #bdc3c7, #2c3e50)",
          color: "#fff",
        }; // Default Grey Gradient
    }
  };

  const formatDate = (dateString) =>
    moment(dateString).format("MMMM D, YYYY");


  const getColorForActionType = (actionType) => {
    switch (actionType) {
      case "Lead Created by Agent":
        return "linear-gradient(to right, #42e695, #3bb2b8)"; // Green-Teal Gradient
      case "Lead Created by bulk upload":
        return "linear-gradient(to right, #ff7e5f, #feb47b)"; // Peach-Orange Gradient
      case "Lead Created by BDM":
        return "linear-gradient(to right, #ff7e5f, #feb47b)"; // Peach-Orange Gradient
      case "Follow-up by Agent":
        return "linear-gradient(to right, #6a11cb, #2575fc)"; // Purple-Blue Gradient
      case "On Call Discussion By BDM":
        return "linear-gradient(to right, #ff9966, #ff5e62)"; // Orange-Red Gradient
      case "Meeting Completed":
        return "linear-gradient(to right, #f857a6, #ff5858)"; // Pink-Red Gradient
        case "Meeting_Office Completed":
        return "linear-gradient(to right, #f857a6, #ff5858)"; // Pink-Red Gradient
      case "Site Visit Completed":
        return "linear-gradient(to right, #43cea2, #185a9d)"; // Teal-Navy Blue Gradient
        case "Meeting_Field Completed":
        return "linear-gradient(to right, #43cea2, #185a9d)"; // Teal-Navy Blue Gradient
      case "Estimation Requested":
        return "linear-gradient(to right, #00c6ff, #0072ff)"; // Light Blue-Dark Blue Gradient
      case "Estimation Need for Approval":
        return "linear-gradient(to right, #f7971e, #ffd200)"; // Orange-Yellow Gradient
      case "Estimation Generated":
        return "linear-gradient(to right, #4facfe, #00f2fe)"; // Sky Blue Gradient
      case "Estimation Shared":
        return "linear-gradient(to right, #36d1dc, #5b86e5)"; // Cyan-Indigo Gradient
      case "Estimation Rejected":
        return "linear-gradient(to right, #36d1dc, #5b86e5)"; // Cyan-Indigo Gradient
      case "Lead Converted":
        return "linear-gradient(to right, #56ab2f, #a8e063)"; // Green Gradient
      case "Lead Edited By Manual":
        return "linear-gradient(to right, #f39c12, #d35400)";
      case "Lead Edited By Call":
        return "linear-gradient(to right, #f39c12, #d35400)";
      case "Lead Edited by Supervisor":
        return "linear-gradient(to right, #f39c12, #d35400)";
      default:
        return "linear-gradient(to right, #bdc3c7, #2c3e50)"; // Default Grey Gradient
    }
  };

  return (
    <VerticalTimeline>
      {/* Static timeline element for a special case */}
      <VerticalTimelineElement
        iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}
        icon={<StarIcon />}
      />

      {/* Map over timelineData to create dynamic timeline elements */}
      {timelineData.map((log, index) => (
        <VerticalTimelineElement
          key={index}
          className={`vertical-timeline-element--${log.action_type
            ?.toLowerCase()
            .replace(/ /g, "-")}`}
          date={
            <div
              style={{
                marginRight: "10px",
                marginLeft: "10px",
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              <span>
                {log.createdAt
                  ? moment(log.createdAt).format("MMMM D, YYYY")
                  : ""}
              </span>
              <br />
              <span>
                {log.createdAt ? moment(log.createdAt).format("h:mm A") : ""}
              </span>
            </div>
          }
          iconStyle={{ ...getIconStyle(log.action_type) }}
          icon={getIcon(log.action_type)}
        >
          {log.action_type === "Lead Edited By Manual" ||
          log.action_type === "Lead Edited By Call" ||
          log.action_type === "Lead Edited by Supervisor" ? (
            // Special rendering for "Pending Lead Update"
            <div>
              <div style={{ marginBottom: "5px" }}>
                <Chip
                  label={log.action_type}
                  style={{
                    background: getColorForActionType(log.action_type),
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "10px 6px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    letterSpacing: "0.5px",
                  }}
                />
              </div>

              <h4 className="vertical-timeline-element-subtitle">
                Changes made by <strong>{log.performed_by}</strong>
              </h4>
              <ul style={{ paddingLeft: "20px", marginTop: "2px" }}>
                {log.formattedChanges?.formattedChanges.map((change, idx) => (
                  <li
                    key={idx}
                    style={{ marginBottom: "8px", listStyle: "disc" }}
                  >
                    <strong>{change.field}:</strong>{" "}
                    {change.from ? (
                      <>
                        Changed from <em>{change.from || "-"}</em> to{" "}
                        <em>{change.to || "-"}</em>
                      </>
                    ) : (
                      <>
                        Added <em>{change.to || "-"}</em>
                      </>
                    )}
                  </li>
                ))}
              </ul>
              {/* <p>
                <strong>Remarks:</strong>{" "}
                {log.formattedChanges?.changes.find(
                  (change) => change.field === "Remarks"
                )?.to || "No remarks provided."}
              </p> */}
            </div>
          ) : (
            // Default rendering for other action types
            <div>
              <div style={{ marginBottom: "5px" }}>
                <Chip
                  label={log.action_type}
                  style={{
                    background: getColorForActionType(log.action_type),
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "10px 6px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    letterSpacing: "0.5px",
                  }}
                />
              </div>
              <h4 className="vertical-timeline-element-subtitle">
                Status updated as{" "}
                <span style={{ textTransform: "capitalize" }}>
                  <strong>{log.category}</strong>
                </span>{" "}
                by{" "}
                <span style={{ textTransform: "capitalize" }}>
                  <strong>{log.performed_by}</strong>{" "}
                </span>{" "}
                on {formatDate(log.createdAt)}
              </h4>
              <p
                style={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  marginTop: "5px",
                }}
              >
                <strong>Sub-Category:</strong> {log.sub_category}
                <br />
                <strong>Remark:</strong> {log.remarks}
                <br />
                <strong>Next follow-up on</strong>{" "}
                {log.follow_up_date === null
                  ? "-"
                  : formatDate(log.follow_up_date)}
              </p>
            </div>
          )}
        </VerticalTimelineElement>
      ))}
    </VerticalTimeline>
  );
};

export default LogTimelineComponent;
